import api from "app/api";

export interface PasswordRecoveryRequestForm {
  email: string;
}

export async function passwordRecoveryRequest(item: PasswordRecoveryRequestForm) {
  return api.post(
    '/identity/password-recovery-request',
    {
      PasswordActivationForm: item,
    },
    {
      public: true,
    }
  );
}